import {
  // ── Navigation / entities ──────────────────────────────────────────
  LayoutDashboard,
  BarChart3,
  Users,
  User,
  DollarSign,
  IndianRupee,
  FileText,
  Building2,
  Building,
  Receipt,
  CreditCard,
  CheckSquare,
  Repeat,
  Ticket,
  ShoppingBag,
  ShoppingCart,
  TrendingUp,
  UserCheck,
  UserPlus,
  Settings,
  Package,
  FileCode,
  MessageSquare,
  Gift,
  Folder,
  FolderOpen,
  LogOut,
  Bell,
  CheckCircle,
  FileSpreadsheet,
  Landmark,
  Target,
  Briefcase,
  Home,
  // ── Status / semantic ──────────────────────────────────────────────
  Check,
  CheckCircle2,
  X,
  XCircle,
  Ban,
  AlertTriangle,
  AlertCircle,
  Info,
  HelpCircle,
  Clock,
  Hourglass,
  Timer,
  Wallet,
  BadgeCheck,
  // ── Actions ────────────────────────────────────────────────────────
  Eye,
  Download,
  Upload,
  Inbox,
  FileCheck,
  RefreshCw,
  Calendar,
  CalendarClock,
  Phone,
  PhoneCall,
  Mail,
  Send,
  Sparkles,
  Search,
  ArrowRight,
  ArrowLeft,
  CornerDownLeft,
  Plus,
  Trash2,
  Pencil,
  Star,
  Rocket,
  ClipboardList,
  ClipboardCheck,
  ListChecks,
  ThumbsUp,
  Lock,
  ShieldCheck,
  Menu,
  ListFilter,
} from "lucide-react";

// ─────────────────────────────────────────────────────────────────────
// Centralized icon registry. Map semantic keys → lucide-react components.
// Use via the <Icon name="..." /> component (src/components/Icon.jsx) or
// getIcon() in core/helpers.js. This replaces the old emoji "icon" tags
// that used to live in JSON/data and JSX across the codebase.
// ─────────────────────────────────────────────────────────────────────
export const IconProperties = {
  // ── Navigation / modules ──
  dashboard: LayoutDashboard,
  analytics: BarChart3,
  employeeAnalytics: Users,
  billingSummary: IndianRupee,
  reports: FileText,
  clients: Building2,
  invoices: Receipt,
  payments: CreditCard,
  tasks: CheckSquare,
  recurringTasks: Repeat,
  tickets: Ticket,
  marketplace: ShoppingBag,
  crossSell: TrendingUp,
  employees: Users,
  directors: UserCheck,
  organisation: Settings,
  bundles: Package,
  templates: FileCode,
  usersRoles: UserPlus,
  kraya: MessageSquare,
  gifts: Gift,
  folder: Folder,
  folderOpen: FolderOpen,
  logout: LogOut,
  bell: Bell,
  checkCircle: CheckCircle,
  spreadsheet: FileSpreadsheet,

  // ── Entities / generic ──
  building: Building2,
  company: Building,
  home: Home,
  user: User,
  users: Users,
  doc: FileText,
  file: FileText,
  fileCheck: FileCheck,
  package: Package,
  receipt: Receipt,
  card: CreditCard,
  wallet: Wallet,
  money: IndianRupee,
  bank: Landmark,
  target: Target,
  briefcase: Briefcase,
  gift: Gift,
  cart: ShoppingCart,
  shop: ShoppingBag,
  message: MessageSquare,
  whatsapp: MessageSquare,
  mail: Mail,
  phone: Phone,
  phoneCall: PhoneCall,
  bellAlert: Bell,
  sparkles: Sparkles,
  rocket: Rocket,
  star: Star,
  lock: Lock,
  shield: ShieldCheck,

  // ── Status (tasks / invoices) ──
  open: Inbox,
  pending: Clock,
  teamAction: Clock,
  paymentPending: Wallet,
  clientAction: AlertCircle,
  teamApproval: Hourglass,
  govtApproval: Landmark,
  completed: CheckCircle,
  cancelled: Ban,
  unpaid: XCircle,
  overdue: AlertTriangle,
  pendingReview: Inbox,
  partial: Timer,
  paid: BadgeCheck,
  approved: CheckCircle2,
  changesRequested: CornerDownLeft,

  // ── Semantic states ──
  check: Check,
  checkCircle2: CheckCircle2,
  success: CheckCircle,
  close: X,
  cancel: XCircle,
  ban: Ban,
  warning: AlertTriangle,
  alert: AlertCircle,
  info: Info,
  help: HelpCircle,
  clock: Clock,
  hourglass: Hourglass,
  timer: Timer,
  thumbsUp: ThumbsUp,

  // ── Actions ──
  view: Eye,
  eye: Eye,
  download: Download,
  upload: Upload,
  review: Inbox,
  refresh: RefreshCw,
  repeat: Repeat,
  calendar: Calendar,
  calendarClock: CalendarClock,
  send: Send,
  search: Search,
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  back: ArrowLeft,
  undo: CornerDownLeft,
  add: Plus,
  plus: Plus,
  trash: Trash2,
  edit: Pencil,
  clipboard: ClipboardList,
  clipboardCheck: ClipboardCheck,
  checklist: ListChecks,
  settings: Settings,
  menu: Menu,
  filter: ListFilter,
};

export default IconProperties;
